import React, { useEffect, useState } from 'react';

import { Divider, Grid, Typography } from '@mui/material';

import {
    Text,
    Button,
    Select,
    Switch,
    Tabs,
    Documents,
    Combo,
    Document,
    DataGridPro as DataGrid
} from 'core/components';

import * as enums from 'core/enums';
import * as icons from 'core/icons';
import List from '../../../../../../store/List';

import DetailFormato from 'views/maestros/Etiquetas/Detalle';
import DetailMarca from '../../../../../maestros/Marcas/Detalle';
import { statesEntity } from 'core/enums';
import { ENTITY_EXPLOTACION_BODEGA } from '../../../../../../store/entities/constants';
import DetailExplotacion from '../../../../../maestros/Explotaciones/Detalle';
import { DateTime } from 'luxon';
import * as helpers from '../../../../../../core/helpers';
import * as hlprs from '../../../../../../core/components/helpers';

const ComboTipoVino = List(Combo, 'options', 'lsttipovino');
const ComboVariedadUva = List(Combo, 'options', 'lstvariedaduva');
const ComboDestino = List(Combo, 'options', 'lstcentrosdestino');

let timeBoxCodigo = 0;

const getCantidadDestino = (
    cantidad,
    añada,
    cantidadMezcla,
    añadaMezcla,
    añadaDestino
) => {
    let grande = 0;
    let pequeña = 0;

    if ((añada === añadaMezcla) === añadaDestino) return 0;

    if (añadaDestino === añada) {
        grande = Number(cantidad);
        pequeña = Number(cantidadMezcla);
    }

    if (añadaDestino === añadaMezcla) {
        grande = Number(cantidadMezcla);
        pequeña = Number(cantidad);
    }

    const maximo = ((grande * 15) / 100).toFixed(2);

    if (pequeña > maximo) return 0;

    return grande + pequeña;
};

const validaCantidad = (values, row) => {
    const añadaCantidad = row.añada;
    const añadaMezcla = row.añadaMezcla;
    const añadaDestino = row.añadaDestino;
    const cantidad =
        values[0].value && values[0].value !== '' ? Number(values[0].value) : 0;
    const cantidadMezcla =
        row.cantidadMezcla && row.cantidadMezcla !== ''
            ? Number(row.cantidadMezcla)
            : 0;
    const cantidadDestino = getCantidadDestino(
        cantidad,
        añadaCantidad,
        cantidadMezcla,
        añadaMezcla,
        añadaDestino
    );

    values.push({
        field: 'cantidadDestino',
        value: cantidadDestino.toFixed(2)
    });

    return values;
};

const validaCantidadMezcla = (values, row) => {
    const añadaCantidad = row.añada;
    const añadaMezcla = row.añadaMezcla;
    const añadaDestino = row.añadaDestino;
    const cantidadMezcla =
        values[0].value && values[0].value !== '' ? Number(values[0].value) : 0;
    const cantidad =
        row.cantidad && row.cantidad !== '' ? Number(row.cantidad) : 0;
    const cantidadDestino = getCantidadDestino(
        cantidad,
        añadaCantidad,
        cantidadMezcla,
        añadaMezcla,
        añadaDestino
    );

    values.push({
        field: 'cantidadDestino',
        value: cantidadDestino.toFixed(2)
    });

    return values;
};

const validaAñada = (values, row, fieldName) => {
    const cantidad = row.cantidad ? Number(row.cantidad) : 0;
    const cantidadMezcla = row.cantidadMezcla ? Number(row.cantidadMezcla) : 0;
    const añada = fieldName === 'añada' ? values[0].value : row.añada;
    const añadaMezcla =
        fieldName === 'añadaMezcla' ? values[0].value : row.añadaMezcla;
    const añadaDestino =
        fieldName === 'añadaDestino' ? values[0].value : row.añadaDestino;
    const cantidadDestino = getCantidadDestino(
        cantidad,
        añada,
        cantidadMezcla,
        añadaMezcla,
        añadaDestino
    );

    values.push({
        field: 'cantidadDestino',
        value: cantidadDestino.toFixed(2)
    });

    return values;
};

const validaPorcentaje = (values, row) => {
    const porcentaje =
        values[0].value && values[0].value !== '' ? Number(values[0].value) : 0;
    const total = row.total && row.total !== '' ? Number(row.total) : 0;
    const cantidad = (porcentaje / 100) * total;

    values.push({ field: 'total', value: total.toFixed(2) });
    values.push({ field: 'cantidad', value: cantidad.toFixed(2) });

    return values;
};

const validaTotal = (values, row) => {
    const total =
        values[0].value && values[0].value !== '' ? Number(values[0].value) : 0;
    const porcentaje =
        row.porcentaje && row.porcentaje !== '' ? Number(row.porcentaje) : 0;
    const cantidad = (porcentaje / 100) * total;

    values.push({ field: 'porcentaje', value: porcentaje.toFixed(2) });
    values.push({ field: 'cantidad', value: cantidad.toFixed(2) });

    return values;
};

const cols = (name, row, index, editing, handleChange, tipo) => [
    {
        key: 'tipoVino',
        title: 'Tipo Vino',
        align: 'left',
        width: '20%',
        component: row && (
            <ComboTipoVino
                fullWidth
                variant='standard'
                api='auxiliares/variedadesvino/'
                name='tipoVino'
                nameKey='tipoVinoId'
                Icon={icons.WineIcon}
                value={row.tipoVino}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'variedadUva',
        title: 'Variedad Uva',
        align: 'left',
        width: '20%',
        component: row && (
            <ComboVariedadUva
                fullWidth
                variant='standard'
                api='auxiliares/variedadesUva/'
                name='variedadUva'
                nameKey='variedadUvaId'
                Icon={icons.VarietyIcon}
                value={row.variedadUva}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'mesesMadera',
        title: 'Meses Madera',
        align: 'left',

        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='mesesMadera'
                variant='standard'
                margin='none'
                type='entero'
                value={row.mesesMadera}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'añada',
        title: 'Añada',
        align: 'left',

        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={editing}
                name='añada'
                margin='none'
                type='0.4'
                value={row.añada}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'grado',
        title: 'Grado',
        align: 'left',

        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='grado'
                variant='standard'
                margin='none'
                type='d.2'
                value={row.grado}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    },
    {
        key: 'total',
        title: 'Total',
        align: 'left',

        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='total'
                variant='standard'
                margin='none'
                type='d.2'
                value={row.total}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(validaTotal(values, row), name, index))
                }
            />
        )
    },
    {
        key: 'porcentaje',
        title: '%',
        align: 'left',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='porcentaje'
                variant='standard'
                margin='none'
                type='d.2'
                value={row.porcentaje}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaPorcentaje(values, row),
                            name,
                            index
                        ))
                }
            />
        )
    },
    {
        key: 'cantidad',
        title: 'Cantidad',
        align: 'right',
        component: row && hlprs.getValueFormatted('d.2', row.cantidad)
    }
];
const colsMezcla = (
    name,
    row,
    index,
    editing,
    handleChange,
    tipo,
    handleError
) => [
    {
        key: 'cantidad',
        title: 'Cantidad',
        align: 'center',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='cantidad'
                variant='standard'
                margin='none'
                type='d.2'
                value={row.cantidad}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(validaCantidad(values, row), name, index))
                }
            />
        )
    },
    {
        key: 'añada',
        title: 'Añada',
        align: 'center',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={editing}
                name='añada'
                margin='none'
                type='0.4'
                value={row.añada}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaAñada(values, row, 'añada'),
                            name,
                            index
                        ))
                }
            />
        )
    },
    {
        key: 'tipoVino',
        title: 'Tipo Vino',
        align: 'left',
        width: '15%',
        component: row && (
            <ComboTipoVino
                fullWidth
                variant='standard'
                api='auxiliares/variedadesvino/'
                name='tipoVino'
                nameKey='tipoVinoId'
                Icon={icons.WineIcon}
                value={row.tipoVino}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'cantidadMezcla',
        title: 'Cantidad',
        align: 'left',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='cantidadMezcla'
                variant='standard'
                margin='none'
                type='d.2'
                value={row.cantidadMezcla}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaCantidadMezcla(values, row),
                            name,
                            index
                        ))
                }
            />
        )
    },
    {
        key: 'añadaMezcla',
        title: 'Añada',
        align: 'left',
        component: row && (
            <Text
                fullWidth
                variant='standard'
                editing={editing}
                name='añadaMezcla'
                margin='none'
                type='0.4'
                value={row.añadaMezcla}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaAñada(values, row, 'añadaMezcla'),
                            name,
                            index
                        ))
                }
            />
        )
    },
    {
        key: 'tipoVinoMezcla',
        title: 'Tipo Vino',
        align: 'left',
        width: '15%',
        component: row && (
            <ComboTipoVino
                fullWidth
                variant='standard'
                api='auxiliares/variedadesvino/'
                name='tipoVinoMezcla'
                nameKey='tipoVinoMezclaId'
                Icon={icons.WineIcon}
                value={row.tipoVinoMezcla}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'cantidadDestino',
        title: 'Cantidad Final',
        align: 'left',
        component: row && (
            <Typography
                color={Number(row.cantidadDestino) === 0 ? 'red' : 'black'}
            >
                {Number(row.cantidadDestino) === 0
                    ? '>15%'
                    : hlprs.getValueFormatted('d.2', row.cantidadDestino)}
            </Typography>
        )
    },
    {
        key: 'añadaDestino',
        title: 'Añada Final',
        align: 'left',
        component: row && (
            <Text
                fullWidth
                onError={handleError}
                error={
                    row.cantidadDestino === '' ||
                    Number(row.cantidadDestino) === 0
                }
                variant='standard'
                editing={editing}
                name='añadaDestino'
                margin='none'
                type='0.4'
                value={row.añadaDestino}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values =>
                        handleChange(
                            validaAñada(values, row, 'añadaDestino'),
                            name,
                            index
                        ))
                }
            />
        )
    },
    {
        key: 'tipoVinoDestino',
        title: 'Tipo Vino Final',
        align: 'left',
        width: '15%',
        component: row && (
            <ComboTipoVino
                fullWidth
                variant='standard'
                api='auxiliares/variedadesvino/'
                name='tipoVinoDestino'
                nameKey='tipoVinoDestinoId'
                Icon={icons.WineIcon}
                value={row.tipoVinoDestino}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    }
];

const Almacenamiento = props => {
    const {
        values,
        editing,
        handleChange,
        handleError,
        refresh,
        execAction,
        reload,
        getApiCentros
    } = props;

    const [cantidadTotal, setCantidadTotal] = useState(0);

    useEffect(() => {
        if (!values.tipo.mezcla) {
            calculaTotales();
        }
    }, [JSON.stringify(values.detalleAlmacenamiento)]);

    const calculaTotales = () => {
        let newCantidadTotal = 0;

        if (values && values.detalleAlmacenamiento) {
            values.detalleAlmacenamiento.forEach(detalle => {
                newCantidadTotal += Number(detalle.cantidad);
            });
        }

        setCantidadTotal(newCantidadTotal);
    };

    const actualizaCodigo = () => {
        if (editing) {
            const action = () => {
                const accion = {
                    api: 'tramites/numerocontrol',
                    metodo: 'post',
                    data: {
                        fields: ['numControl'],
                        values: { ...values }
                    }
                };
                execAction(accion, [reload]);
            };

            timeBoxCodigo > 0 && clearTimeout(timeBoxCodigo);
            timeBoxCodigo = setTimeout(action, 250);
        }
    };

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Grid container direction='column' spacing={2}>
                        {!values.tipo.mezcla && (
                            <Grid item xs>
                                <Grid
                                    container
                                    justifyContent={'space-around'}
                                    alignItems={'center'}
                                >
                                    <Grid item xs>
                                        <Grid
                                            sx={{
                                                marginTop: '10px',
                                                marginBottom: '10px',
                                                backgroundColor: 'lightgray',
                                                height: 25,
                                                borderRadius: 1
                                            }}
                                            container
                                            justifyContent={'space-around'}
                                            alignItems={'center'}
                                        >
                                            <Grid item>
                                                <Typography variant={'h5'}>
                                                    {'Desglose Almacenamiento'}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant={'h5'}>
                                                    {`Cantidad Total: ${helpers.getValueFormatted('d.2', cantidadTotal)}`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        <Grid item xs>
                            <DataGrid
                                name='detalleAlmacenamiento'
                                editing={editing}
                                rows={
                                    values.detalleAlmacenamiento
                                        ? values.detalleAlmacenamiento
                                        : []
                                }
                                cols={(name, row, index) =>
                                    values.tipo.mezcla
                                        ? colsMezcla(
                                              name,
                                              row,
                                              index,
                                              editing,
                                              handleChange,
                                              values.tipo,
                                              handleError
                                          )
                                        : cols(
                                              name,
                                              row,
                                              index,
                                              editing,
                                              handleChange,
                                              values.tipo
                                          )
                                }
                                onAdd={name => {
                                    handleChange(
                                        {
                                            linea:
                                                values.detalleAlmacenamiento &&
                                                values.detalleAlmacenamiento
                                                    .length !== 0
                                                    ? values
                                                          .detalleAlmacenamiento[
                                                          values
                                                              .detalleAlmacenamiento
                                                              .length - 1
                                                      ].linea + 1
                                                    : 1,
                                            total: (0).toFixed(2),
                                            porcentaje: (100).toFixed(2),
                                            cantidad: (0).toFixed(2),
                                            cantidadMezcla: (0).toFixed(2),
                                            cantidadDestino: (0).toFixed(2)
                                        },
                                        name
                                    );
                                }}
                                onDelete={(name, index) =>
                                    handleChange(
                                        undefined,
                                        name,
                                        (index + 1) * -1
                                    )
                                }
                                minHeight={250}
                                maxHeight={250}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {values.tipo && (values.tipo.traspaso || values.tipo.venta) && (
                    <Grid item xs={5}>
                        <Grid container direction='column' spacing={2}>
                            <Grid item xs>
                                <Grid container spacing={2}>
                                    <Grid item xs>
                                        <ComboDestino
                                            required
                                            fullWidth
                                            api={getApiCentros(values)}
                                            name='explotacionDestino'
                                            nameKey='explotacionDestinoId'
                                            label='Destino'
                                            relacionado={{
                                                api: 'explotaciones',
                                                type: ENTITY_EXPLOTACION_BODEGA,
                                                Detail: DetailExplotacion,
                                                resume: ['nombre'],
                                                readOnly: false
                                            }}
                                            refresh={refresh}
                                            Icon={icons.SitesIcon}
                                            value={values.explotacionDestino}
                                            onChange={handleChange}
                                            onError={handleError}
                                            editing={editing}
                                            propertyValue='id'
                                            getOptionLabel={option =>
                                                `${option.codigo}-${option.nombre}-[${option.bodega.nombre}]`
                                            }
                                            searchKeys={[
                                                'codigo',
                                                'nombre',
                                                'bodega.nombre'
                                            ]}
                                            /*filters={[
                                                {
                                                    fields: ['almacenamiento'],
                                                    values: ['Activo'],
                                                    operator: 'in',
                                                    type: 'text'
                                                }
                                            ]}*/
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs>
                                <Grid container spacing={2}>
                                    <Grid item xs>
                                        <Text
                                            //required
                                            fullWidth
                                            name='numeroDocumento'
                                            label='Numero Documento / Albaran interno'
                                            value={values.numeroDocumento}
                                            onChange={handleChange}
                                            onError={handleError}
                                            editing={editing}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Text
                                            fullWidth
                                            name='numControl'
                                            label='Numero de Control'
                                            value={values.numControl}
                                            editing={editing}
                                            nextValue={
                                                editing && actualizaCodigo
                                            }
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs>
                                <Grid
                                    container
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    spacing={2}
                                >
                                    <Grid item xs>
                                        <Grid
                                            container
                                            direction={'column'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                        >
                                            <Typography
                                                variant={'h5'}
                                                sx={{ marginBottom: '5px' }}
                                            >
                                                Documento Presentado
                                            </Typography>
                                            <Document
                                                //objectFit={'cover'}
                                                name='documentoOficial'
                                                readOnly={!editing}
                                                width='200px'
                                                height='200px'
                                                value={values.documentoOficial}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </form>
    );
};

export default Almacenamiento;
